import { isRecord } from '@cli-utils/shared.js'
import { parseSchemaJson } from '@core-engine/schema/schema-reader/parse-schema-json.js'

export function parseJsonObject(content: string, filePath: string): Record<string, unknown> {
  const parsed = parseSchemaJson(content, filePath)

  if (!isRecord(parsed)) {
    throw new Error(`Schema file must contain a JSON object: ${filePath}`)
  }

  return parsed
}
